import { compose, setDisplayName, withState, withHandlers } from 'recompose';

const enhance = compose(
  setDisplayName('FixModal'),
  withState('redListCheck', 'updateRedListCheck', false),
  withState('rareSpeciesCheck', 'updateRareSpeciesCheck', false),
  withState('parasiteCheck', 'updateParasiteCheck', false),
  withHandlers({
    toggleRedList: (props) => () => {
      const { updateRedListCheck, redListCheck } = props;
      updateRedListCheck(!redListCheck);
    },
    toggleRareSpecies: (props) => () => {
      const { updateRareSpeciesCheck, rareSpeciesCheck } = props;
      updateRareSpeciesCheck(!rareSpeciesCheck);
    },
    toggleParasiteCheck: (props) => () => {
      const { updateParasiteCheck, parasiteCheck } = props;
      updateParasiteCheck(!parasiteCheck);
    },
  })
);

export default enhance;
